import React from 'react';

import { ListItemButton, ListItemIcon } from '@mui/material';
import { Link } from 'react-router-dom';

import SectionTitle from './SectionTitle';

interface SelectedListButtonProps {
  label1: string;
  label2: string;
  path: string; // assuming the To type you mentioned is string. Replace with appropriate type if not.
  icon: React.ElementType; // assuming it's a React component. Adjust as needed.
  isSelected: boolean;
  onClick: (path: string) => void;
  onPress: (path: string) => (event: React.KeyboardEvent) => void;
}

export default function SelectedListButton({
  label1,
  label2,
  path,
  icon: IconComponent,
  isSelected,
  onClick,
  onPress,
}: SelectedListButtonProps) {
  return (
    <ListItemButton
      component={Link}
      to={path}
      selected={isSelected}
      aria-current={isSelected ? 'page' : undefined}
      onClick={(event) => {
        if (
          event.button === 0 &&
          !event.metaKey &&
          !event.ctrlKey &&
          !event.shiftKey &&
          !event.altKey
        ) {
          onClick(path);
        }
      }}
      onKeyDown={(event) => onPress?.(path)?.(event)}
      sx={{
        padding: '20px',
        '&.Mui-selected': {
          backgroundColor: '#D9F4FF',
          color: '#0B2545',
          '& .blue, & .grey': {
            color: '#0B2545',
            fontWeight: '700',
          },
        },
        '&.Mui-focusVisible': {
          backgroundColor: '#D9F4FF',
          color: '#0B2545',
          outline: '3px solid #005596',
          outlineOffset: '-3px',
          '& .blue, & .grey': {
            color: '#0B2545',
          },
        },
        ':hover': {
          backgroundColor: '#e7e2e2',
          color: 'black',
          cursor: 'pointer',
          '& .blue, & .grey': {
            color: 'black',
          },
        },
      }}
    >
      <ListItemIcon>
        <IconComponent
          sx={{
            ':hover': {
              color: 'black',
            },
          }}
        />
      </ListItemIcon>
      <SectionTitle
        first={label1}
        second={label2}
        type='menu'
        variant='subtitle1'
        padding='0'
      />
    </ListItemButton>
  );
}
